<template>
  <div>
    <div class="pbtn">
      <i class="iconfont screen" @click="display = true">&#xe63f;</i>
      <el-popover placement="bottom-start" width="140" trigger="hover">
        <ul class="file_button_group">
          <li :style="limitType == 1 ? usablePackageList.length == 0 ? 'cursor: no-drop;' : '' : limitType == 2 ? invalidPackageList.length == 0 ? 'cursor: no-drop;' : '' : allPackageList.length == 0 ? 'cursor: no-drop;' : ''" @click="limitType == 1 ? usablePackageList.length == 0 ? '' : onDownload() : limitType == 2 ? invalidPackageList.length == 0 ? '' : onDownload() : allPackageList.length == 0 ? '' : onDownload()">导出报表</li>
          <li :style="limitType == 1 ? usablePackageList.length == 0 ? 'cursor: no-drop;' : '' : limitType == 2 ? invalidPackageList.length == 0 ? 'cursor: no-drop;' : '' : allPackageList.length == 0 ? 'cursor: no-drop;' : ''" @click="limitType == 1 ? usablePackageList.length == 0 ? '' : onPrint() : limitType == 2 ? invalidPackageList.length == 0 ? '' : onPrint() : allPackageList.length == 0 ? '' : onPrint()">打印报表</li>
        </ul>
        <i slot="reference" class="iconfont screenOne">&#xe61f;</i>
      </el-popover>
    </div>
    <div class="pageOverflow">
      <div v-if="Lib.checkPower('beauty-3-ckgktcxx2',2)" v-loading="loading" class="pageFlex">
        <drawer title="套餐筛选" :display.sync="display">
          <div class="li">
            <p>套餐类型</p>
            <el-button size="small" round :plain="limitType == '' ? false : true" type="primary" @click="changeMeal('')">全部套餐（{{ allPackageList.length }}）</el-button>
            <el-button size="small" round :plain="limitType == 1 ? false : true" type="primary" @click="changeMeal(1)">可用套餐（{{ usablePackageList.length }}）</el-button>
            <el-button size="small" round :plain="limitType == 2 ? false : true" type="primary" @click="changeMeal(2)">失效套餐（{{ invalidPackageList.length }}）</el-button>
          </div>
        <!-- <div class="dfoot" @click="resetScreen">重置</div> -->
        </drawer>

        <div v-if="allPackageList.length > 0 && limitType == ''" class="beauty_content calc_T">
          <ul class="calc_ul">
            <li v-for="(item,index) in allPackageList" :key="index">
              <div class="liLeft">
                <div class="img">
                  <gt-coverImg :img-class="'liOne_img'" :img-url="item.vipCardImgUrl" :default-img="'static/images/card_bg.png'"></gt-coverImg>
                </div>
              </div>
              <div class="liRight">
                <h4>{{ item.vipCardName }}<del>￥{{ (item.itemsPrice*1+item.productsPrice*1).toFixed(2) }}</del></h4>
                <h5>
                  <!-- <label>到期时间：</label>{{ item.endTime }} -->
                  <label>{{ item.validType == 1 ? '有效时间：' : item.validType == 2 ? '使用期限：' : '有效天数：' }}</label>
                  {{ item.validType == 1 ? (item.startTime+'至'+ item.endTime) : item.validType == 2 ? '永久有效' : ((item.validTime ? item.validTime : '0')+'天') }}
                  <span>￥{{ item.price }}</span>
                </h5>
                <h3>
                  <samp @click="openListy(item.id || item.eitemId,item.clientVipCardId)">详情<i class="el-icon-arrow-right"></i></samp>
                </h3>
              </div>

              <div class="liTop" :class="item.type == 2 ? 'liCone' : item.type == 3 ? 'liCtwo' : 'liCthree'">{{ item.type == 2 ? (item.countLimitType == 2 ? '已拥有，无限次数' : ('已拥有，剩余'+item.beUsedCount+'次')) : item.type == 3 ? '已用完' : '已过期' }}</div>
            </li>
          </ul>
        </div>
        <div v-if="allPackageList.length == 0 && limitType == ''" style="color: #999;text-align: center;font-size: 14px;margin-top:20px">该顾客没有购买套餐</div>

        <div v-if="usablePackageList.length > 0 && limitType == 1" class="beauty_content calc_T">
          <ul class="calc_ul">
            <li v-for="(item,index) in usablePackageList" :key="index">
              <div class="liLeft">
                <div class="img">
                  <gt-coverImg :img-class="'liOne_img'" :img-url="item.imgUrl" :default-img="'static/images/card_bg.png'"></gt-coverImg>
                </div>
              </div>
              <div class="liRight">
                <h4>{{ item.vipCardName }}<del>￥{{ (item.itemsPrice*1+item.productsPrice*1).toFixed(2) }}</del></h4>
                <h5>
                  <!-- <label>到期时间：</label>{{ item.endTime }} -->
                  <label>{{ item.validType == 1 ? '有效时间：' : item.validType == 2 ? '使用期限：' : '有效天数：' }}</label>
                  {{ item.validType == 1 ? (item.startTime+'至'+ item.endTime) : item.validType == 2 ? '永久有效' : ((item.validTime ? item.validTime : '0')+'天') }}
                  <span>￥{{ item.price }}</span>
                </h5>
                <h3>
                  <samp @click="openListy(item.id || item.eitemId,item.clientVipCardId)">详情<i class="el-icon-arrow-right"></i></samp>
                </h3>
              </div>
              <div class="liTop" :class="item.type == 2 ? 'liCone' : item.type == 3 ? 'liCtwo' : 'liCthree'">{{ item.type == 2 ? (item.countLimitType == 2 ? '已拥有，无限次数' : ('已拥有，剩余'+item.beUsedCount+'次')) : item.type == 3 ? '已用完' : '已过期' }}</div>
            </li>
          </ul>
        </div>
        <div v-if="usablePackageList.length == 0 && limitType == 1" style="color: #999;text-align: center;font-size: 14px;margin-top:20px">该顾客没有可用套餐</div>

        <div v-if="invalidPackageList.length > 0 && limitType == 2" class="beauty_content calc_T">
          <ul class="calc_ul">
            <li v-for="(item,index) in invalidPackageList" :key="index">
              <div class="liLeft">
                <div class="img">
                  <gt-coverImg :img-class="'liOne_img'" :img-url="item.imgUrl" :default-img="'static/images/card_bg.png'"></gt-coverImg>
                </div>
              </div>
              <div class="liRight">
                <h4>{{ item.vipCardName }}<del>￥{{ (item.itemsPrice*1+item.productsPrice*1).toFixed(2) }}</del></h4>
                <h5>
                  <!-- <label>到期时间：</label>{{ item.endTime }} -->
                  <label>{{ item.validType == 1 ? '有效时间：' : item.validType == 2 ? '使用期限：' : '有效天数：' }}</label>
                  {{ item.validType == 1 ? (item.startTime+'至'+ item.endTime) : item.validType == 2 ? '永久有效' : ((item.validTime ? item.validTime : '0')+'天') }}
                  <span>￥{{ item.price }}</span>
                </h5>
                <h3>
                  <samp @click="openListy(item.id || item.eitemId,item.clientVipCardId)">详情<i class="el-icon-arrow-right"></i></samp>
                </h3>
              </div>
              <div class="liTop" :class="item.type == 2 ? 'liCone' : item.type == 3 ? 'liCtwo' : 'liCthree'">{{ item.type == 2 ? (item.countLimitType == 2 ? '已拥有，无限次数' : ('已拥有，剩余'+item.beUsedCount+'次')) : item.type == 3 ? '已用完' : '已过期' }}</div>
            </li>
          </ul>
        </div>
        <div v-if="invalidPackageList.length == 0 && limitType == 2" style="color: #999;text-align: center;font-size: 14px;margin-top:20px">该顾客没有无效套餐</div>
      </div>
      <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
      <!--订单详情-->

      <el-dialog title="套餐详情" :visible.sync="cardListShow" width="1000px" class="beauty_setmeal_details">
        <ScribingDetails :show="cardListShow" :details-data="detailsData" :details-loading="detailsLoading" :search-before-phone="phoneSearchVal" :open-listy="openListy" :member-info="customerInfo" :status="2"></ScribingDetails>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getBeautyPackageList,
  getOneCustomerMsg,
  getDeductDetails
} from '../api';
// 6.81
import ScribingDetails from '../../../../stage/template/beautyCard/template/dialog/scribingDetails.vue';
import drawer from '../../../../publicVue/drawer';

export default {
  components: {
    ScribingDetails,
    drawer
  },
  data() {
    return {
      usablePackageList: [],
      invalidPackageList: [],
      cardListShow: false, // 套餐详情弹出
      detailsData: {
        vipCardBuyOrderList: []
      }, // 详情内容
      loading: false, // 加载

      // 5.9
      customerInfo: {},

      // 6.7
      limitType: '',
      allPackageList: [],
      detailsLoading: true,
      phoneSearchVal: '',
      // 6.81
      display: false,
    };
  },
  activated() {
    this.loading = true;
    this.phoneSearchVal = window.sessionStorage.customerPhone;
    this.phoneSearch();
    this.getCustomerMsg();
  },
  methods: {
    // 6.7
    changeMeal(val) {
      this.limitType = val;
    },
    // 5.9
    onDownload() {
      this.$root.$children[0].fatherExport('exportBeautyPackageList', this.phoneSearchVal, this.limitType);
    },
    // 5.9获取顾客信息
    getCustomerMsg() {
      const data = {
        keyWord: this.phoneSearchVal
      };
      getOneCustomerMsg(data).then((res) => {
        if (res.code == 0) {
          this.customerInfo = res.data;
        } else {
          this.customerInfo = {};
        }
      });
    },
    onPrint() {
      this.allPackageList.forEach((a) => {
        a.newTime = a.validType == 1 ? (`${a.startTime}至${a.endTime}`) : a.validType == 2 ? '永久有效' : (`${a.validTime ? a.validTime : '0'}天`);
        a.newType = a.countLimitType == 1 ? '有限次数' : a.countLimitType == 2 ? '无限次数' : '通用次数';
        let storeVal = '';
        a.useStoreList.forEach((b, m) => {
          storeVal += b.name + (a.useStoreList.length == (m + 1) ? '' : '，');
        });
        a.newUseStoreList = storeVal;
        const arr = [];
        a.clientVipCardItemInfoList = (a.clientVipCardItemInfoList || []);
        a.clientPackageProductList = (a.clientPackageProductList || []);
        a.clientVipCardItemInfoList.forEach((c) => {
          arr.push(c);
        });
        a.clientPackageProductList.forEach((d) => {
          arr.push(d);
        });
        a.ppList = arr;
      });
      this.usablePackageList.forEach((a) => {
        a.newTime = a.validType == 1 ? (`${a.startTime}至${a.endTime}`) : a.validType == 2 ? '永久有效' : (`${a.validTime ? a.validTime : '0'}天`);
        a.newType = a.countLimitType == 1 ? '有限次数' : a.countLimitType == 2 ? '无限次数' : '通用次数';
        let storeVal = '';
        a.useStoreList.forEach((b, m) => {
          storeVal += b.name + (a.useStoreList.length == (m + 1) ? '' : '，');
        });
        a.newUseStoreList = storeVal;
        const arr = [];
        a.clientVipCardItemInfoList = (a.clientVipCardItemInfoList || []);
        a.clientPackageProductList = (a.clientPackageProductList || []);
        a.clientVipCardItemInfoList.forEach((c) => {
          arr.push(c);
        });
        a.clientPackageProductList.forEach((d) => {
          arr.push(d);
        });
        a.ppList = arr;
      });
      this.invalidPackageList.forEach((a) => {
        a.newTime = a.validType == 1 ? (`${a.startTime}至${a.endTime}`) : a.validType == 2 ? '永久有效' : (`${a.validTime ? a.validTime : '0'}天`);
        a.newType = a.countLimitType == 1 ? '有限次数' : a.countLimitType == 2 ? '无限次数' : '通用次数';
        let storeVal = '';
        a.useStoreList.forEach((b, m) => {
          storeVal += b.name + (a.useStoreList.length == (m + 1) ? '' : '，');
        });
        a.newUseStoreList = storeVal;
        const arr = [];
        a.clientVipCardItemInfoList = (a.clientVipCardItemInfoList || []);
        a.clientPackageProductList = (a.clientPackageProductList || []);
        a.clientVipCardItemInfoList.forEach((c) => {
          arr.push(c);
        });
        a.clientPackageProductList.forEach((d) => {
          arr.push(d);
        });
        a.ppList = arr;
      });
      this.$print({
        data: this.limitType == 1 ? this.usablePackageList : this.limitType == 2 ? this.invalidPackageList : this.allPackageList,
        title: `${this.customerInfo.nickName}-${this.limitType == 1 ? '可用' : this.limitType == 2 ? '无效' : '全部'}套餐明细汇总`,
        status: 2,
        table_tol: [
          {
            name: '套餐名称',
            prop: 'vipCardName'
          },
          {
            name: '使用期限',
            prop: 'newTime'
          },
          {
            name: '套餐类型',
            prop: 'newType'
          },
          {
            name: '剩余可划扣的项目/产品',
            prop: 'ppList'
          },
          {
            name: '剩余次数',
            prop: 'ppList'
          },
          {
            name: '可用门店',
            prop: 'newUseStoreList'
          }
        ]
      });
    },
    // 查询顾客
    phoneSearch() {
      const vm = this;
      const data = {
        mainId: window.sessionStorage.mainId,
        type: 0,
        phone: vm.phoneSearchVal
      };
      getBeautyPackageList(data).then((res) => {
        if (res.code == 0) {
          res.data ? '' : res.data = [];
          if (res.data.length > 0) {
            const arr = [];
            const arrOne = [];
            const arrTwo = [];
            res.data.forEach((item1) => {
              if (item1.type !== 1) {
                item1.clientVipCardItemInfoList.forEach((item2) => {
                  item2.cardId = item1.id;
                });
              }
              if (item1.type == 2) {
                arrOne.push(item1);
              } else {
                arrTwo.push(item1);
              }
              arr.push(item1);
            });
            this.allPackageList = arr;
            this.usablePackageList = arrOne;
            this.invalidPackageList = arrTwo;
          }
          this.loading = false;
        }
      });
    },
    // 点击弹出详情
    openListy(packageId, clientVipCardId) {
      const data = {
        mainId: window.sessionStorage.mainId,
        phone: this.phoneSearchVal,
        packageId,
        clientVipCardId,
      };
      this.cardListShow = true;
      this.detailsLoading = true;
      getDeductDetails(data).then((res) => {
        if (res.code == 0) {
          res.data.hiddenStatus = false;
          if (res.data.type !== 1) {
            if (res.data.clientVipCardItemInfoList) {
              res.data.clientVipCardItemInfoList.forEach((item2) => {
                item2.isDisabled = 0;
                item2.cardId = res.data.id;
                item2.percentage4ServeList = [];
                item2.count = item2.residueCount >= 1 ? 1 : 0;
                item2.chooseList = [
                  {
                    dictItemName: item2.dictItemName,
                    isDisabled: item2.isDisabled,
                    percentage4ServeList: item2.percentage4ServeList,
                    isPercentage: item2.isPercentage,
                    residueCount: item2.residueCount,
                    itemId: item2.itemId,
                    status: item2.status
                  }
                ];
              });
            }
            if (res.data.clientPackageProductList) {
              res.data.clientPackageProductList.forEach((item3) => {
                item3.isDisabled = 0;
                item3.percentage4ProductList = [];
                item3.count = item3.residueCount >= 1 ? 1 : 0;
                item3.productCount = item3.residueCount == 0 ? 0 : 1;
              });
            }
          }
          this.detailsData = res.data;
        } else {
          console.log(res.data);
        }
        this.detailsLoading = false;
      });
    },
  },
};
</script>

<style>
.el-dialog__body {
  overflow-x: visible !important;
}
.order-details .el-loading-spinner {
  background-position-y: 50%;
  top: 0;
  padding-top: 0;
}
.N_ti {
  color: rgb(210, 210, 210);
  flex: 1;
  position: absolute;
  margin-top: 4px;
}
.N_MD {
  width: 500px;
}
.N_poptext {
  max-width: 50%;
  padding: 5px !important;
}
.newPopper {
  border: 1px solid #e6ebf5 !important;
  padding: 0 !important;
  box-shadow: 2px 4px 10px 0px rgba(53, 53, 53, 0.09);
}
.newPopper .el-tooltip__popper .popper__arrow {
  border-color: #e6ebf5 !important;
}
.el-tooltip__popper.is-light.newPopper .popper__arrow {
  border-color: #e6ebf5 transparent !important;
}
.buckleDetails .right .list .list_left .el-checkbox__label {
  white-space: pre-line !important;
  width: 150px !important;
  vertical-align: middle !important;
  line-height: 16px !important;
}
.packageList ul li .liMiddle {
  width: calc(100% - 420px);
}
.packageList ul li .liMiddle h6 samp {
  width: calc(100% - 70px);
}
</style>

<style lang="less" scoped>
.pbtn {
  position: relative;
  float: right;
  margin-top: -44px;
  height: 20px;
  line-height: 20px;
  .screen {
    color: #999;
    font-size: 20px;
    cursor: pointer;
    margin-right: 10px;
    position: relative;
    z-index: 1;
  }
  .screenOne {
    color: #999;
    font-size: 20px;
    cursor: pointer;
    position: relative;
    z-index: 1;
  }
}
.beauty_content {
  width: 100%;
  ul {
    padding: 5px 0 0 5px;
    li {
      width: 377px;
      height: 110px;
      padding: 30px 20px 20px 20px;
      background: #FFFFFF;
      box-shadow: 0px 2px 6px 1px rgba(0, 0, 0, 0.08);
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      display: flex;
      margin: 0 20px 20px 0;
      float: left;
      position: relative;
      .liTop {
        min-width: 129px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border-radius: 0px 4px 0px 4px;
        position: absolute;
        margin-top: -30px;
        right: 0;
        color: #fff;
        font-size: 14px;
      }
      .liCone {
        background-color: #409EFF;
      }
      .liCtwo {
        background-color: #F56C6C;
      }
      .liCthree {
        background-color: #909399;
      }
      .liLeft {
        flex: 1;
        width: 80px;
        padding-right: 10px;
        .img {
          width: 80px;
          height: 80px;
          .liOne_img {
            width: 100%;
            height: 100%;
            box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.05);
          }
        }
      }
      .liRight {
        width: 295px;
        h1 {
          font-size: 16px;
          color: #333;
          height: 18px;
          line-height: 18px;
        }
        h2 {
          font-size: 12px;
          color: #999;
          height: 16px;
          line-height: 16px;
          label {
            font-size: 14px;
          }
          span {
            float: right;
            color: #333;
            font-size: 14px;
          }
          del {
            float: right;
          }
        }
        h3 {
          height: 49px;
          line-height: 43px;
          border-top: 1px solid #ccc;
          samp {
            float: right;
            font-size: 14px;
            color: #09d8fd;
            cursor: pointer;
            i {
              font-size: 18px;
              position: relative;
              top: 2px;
            }
          }
        }
        h4 {
          font-size: 16px;
          color: #333;
          height: 20px;
          line-height: 20px;
          del {
            font-size: 12px;
            color: #999;
            float: right;
          }
        }
        h5 {
          font-size: 12px;
          color: #999;
          height: 59px;
          line-height: 59px;
          label {
            font-size: 14px;
          }
          span {
            float: right;
            color: #333;
            font-size: 14px;
          }
          del {
            float: right;
          }
        }
      }
    }
  }
}
.file_button_group {
    list-style: none;
    li {
      position: relative;
      z-index: 99;
      padding: 10px 10px;
      font-size: 13px;
      cursor: pointer;
      &:first-of-type {
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
      }
      &:last-of-type {
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
      }
    }
}
.beauty_content {
  clear: both;
  li {
    width: 270px;
    background: #ffffff;
    box-shadow: 0px 2px 10px rgba(4, 0, 0, 0.05);
    display: inline-block;
    margin-right: 18px;
    margin-bottom: 20px;
    .beauty_img {
      position: relative;

      h1 {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 0 10px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        color: #ffffff;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
    .beauty_box {
      padding: 6px 10px;
      background-color: #fff;
      font-size: 14px;
      h2 {
        color: #333333;
        font-size: 14px;
      }
      p {
        padding-top: 3px;
      }
    }
  }
}
.liOne {
  overflow: hidden;
  position: relative;
  height: 270px;
  // .leftCodeNone {
  //   color: #fff;
  //   height: 45px;
  //   line-height: 68px;
  //   width: 80px;
  //   margin: -10px 0px 0 -28px;
  //   position: absolute;
  //   font-size: 14px;
  //   text-align: center;
  //   background-color: #222;
  //   opacity: 0.8;
  //   -webkit-transform: rotate(-45deg);
  //   transform: rotate(-45deg);
  // }
  .liOne_Ti {
    position: absolute;
    left: -2px;
    top: -2px;
  }
  .liOne_img {
    width: 100%;
    height: 100%;
    box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.05);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
}
/*套餐详情*/
.beauty_setmeal_details {
  .top {
    width: 100%;
    height: 100%;
    display: flex;
    text-align: left;
    margin-bottom: 10px;
    .details_img {
      border-radius: 6px;
      width: 200px;
      height: 200px;
      margin-right: 20px;
    }
    .detail_right {
      width: 714px;
      font-size: 14px;
      line-height: 22px;
      color: #303133;
      position: relative;
      p {
        padding-bottom: 10px;
      }
      p :last-child {
        padding-bottom: 0 !important;
      }
      .details_but {
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
  }
  .details_content {
    padding-bottom: 22px;
  }
  .dialog-number {
    float: left;
    margin-top: 20px;
    font-size: 14px;
    color: #606266;
  }
}
.beauty_setmeal_details .details_content .details_top {
  width: 100%;
  height: 19px;
  font-size: 14px;
  line-height: 25px;
  color: #999999;
  display: flex;
  align-items: center;
  margin: 17px 0;
}
.beauty_setmeal_details .details_content .details_top span {
  width: 3px;
  height: 14px;
  line-height: 19px;
  border-radius: 2px;
  display: inline-flex;
  margin-right: 15px;
}
/*公共样式*/
.brauty_font_overflow {
  display: flex;
}
.brauty_font_overflow label {
  max-width: 500px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.useDetails {
  min-height: 300px;
  ul {
    list-style-type: none;
    .noneDetailsData {
      padding: 100px 0 0 0;
      .i {
        display: block;
        text-align: center;
        width: 22px;
        height: 22px;
        line-height: 22px;
        font-size: 17px;
        color: #cecece;
        border: 2px solid #cecece;
        margin: 0 auto;
        border-radius: 50%;
      }
      h6 {
        color: #999;
        font-size: 14px;
        text-align: center;
        height: 40px;
        line-height: 40px;
      }
    }
    li {
      display: flex;
      line-height: 20px;
      .liLeft {
        padding-top: 3px;
        width: 90px;
        font-size: 14px;
        line-height: 16px;
        color: #333;
      }
      .liMiddle {
        width: 31px;
        padding-top: 5px;
        position: relative;
        z-index: 1;
        span {
          display: block;
          width: 17px;
          height: 17px;
          border-radius: 50%;
          background-color: #fff;
          border: 1px solid #d8dce5;
          position: relative;
          margin-left: -1px;
          margin-top: -3px;
          .iconOne {
            display: block;
            width: 11px;
            height: 11px;
            border-radius: 50%;
            margin: 3px;
            background-color: #d8dce5;
          }
        }
        samp {
          display: block;
          width: 11px;
          height: 11px;
          margin: 0 3px;
          border-radius: 50%;
          background-color: #d8dce5;
        }
      }
      .label {
        border-left: 1px solid #d8dce5;
        position: relative;
        top: 6px;
        left: -23px;
        z-index: 0;
      }
      .liRight {
        flex: 1;
        padding-bottom: 30px;
        p {
          font-size: 14px;
          color: #333;
          min-height: 24px;
          line-height: 24px;
          span {
            padding-left: 10px;
          }
        }
        h5 {
          font-size: 14px;
          color: #333;
          min-height: 24px;
          line-height: 24px;
          span {
            padding-right: 20px;
          }
        }
      }
    }
  }
}
// 6.7
.dueTiem{
  width: 714px;
  line-height: 28px;
  .button{
    margin:0 5px;
    font-size: 14px;
  }
}
.popoverBox{
  padding:20px 10px 0 10px;
  overflow: auto;
  h5 {
    font-size: 14px;
    color:#666;
    span {
      float: left;
      width: 72px;
      text-align: right;
    }
  }
  p{
    font-size: 14px;
    color:#606266FF;
    text-align: center;
  }
  .title{
    font-size: 14px;
    color: #303133;
    text-align: left;
  }
  .text{
    margin-bottom:5px;
    font-size: 13px;
    text-align: left;
    display: flex;
    span {
      flex: 1;
    }
    label {
      width: 100px;
      text-align: right;
      samp {
        padding: 0 3px;
      }
    }
  }
}
.package-buttonBox{
  float: right;
  height: 40px;
}
</style>
